import { Navigate, Outlet } from "react-router-dom";
import { isTokenExpired } from "../utils/auth";

const ProtectedRoute = () => {
  const token = localStorage.getItem("authToken");

  if (!token || isTokenExpired()) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
